import { RealtimeUpdate } from './reducer';

const actions = {
  REALTIME_UPDATES_RECIEVED: 'REALTIME_UPDATES_RECIEVED',
  REMOVE_REALTIME_UPDATE: 'REMOVE_REALTIME_UPDATE',

  removeRealtimeUpdate: (id: RealtimeUpdate['id']) => ({
    type: actions.REMOVE_REALTIME_UPDATE,
    payload: id,
  }),
};

export default actions;
